import React from 'react'
import PropTypes from 'prop-types'
import ComposeExtraButton from './compose_extra_button'

const PollButton = ({ disabled, small, poll, onPollToggle }) => (
  <ComposeExtraButton
    title={poll !== null ? 'Remove poll' : 'Add poll'}
    disabled={disabled}
    onClick={onPollToggle}
    icon="poll"
    small={small}
    active={poll !== null}
    iconClassName={_s.cIconComposePoll}
  />
)

PollButton.propTypes = {
  disabled: PropTypes.bool,
  onPollToggle: PropTypes.func,
  small: PropTypes.bool,
  poll: PropTypes.object
}

export default PollButton